import * as React from 'react'
import RequestParameters from "./requestParameters";
import TextParameter from "./textParameter";
import {useTranslation} from "gatsby-plugin-react-i18next";

const SplitOptions = (props) => {
    const {t} = useTranslation();
    const [slidesRange, setSlidesRange] = React.useState("");
    
    function onChange(value) {
        const options = [];
        value !== null && value !== "" && options.push({key: "slidesRange", value: `"${value}"`});
        props.onChange(options)
    }

    return (
        <RequestParameters disable={props.disable}>
            <TextParameter
                value={slidesRange}
                type="string"
                parameter="slidesRange"
                description={t("split-slides-range")}
                onChange={(e) => {
                    setSlidesRange(e.target.value);
                    onChange(e.target.value);
                }}
                disable={props.disable}/>

        </RequestParameters>
    );
}

export default SplitOptions;